/***
 *  Do not import anything that references react u/i or any visual components.
 *  The goal here is to limit the size of the js scripts imported on this page.
 */
import "regenerator-runtime/runtime";

import ReactDOM from "react-dom";
import React from "react";
import { LogLevel, Logger } from "./lib/utils/logging";
import Environment, { DEV, LOCAL } from "lib/utils/environment";
import { AuthenticationContextProvider } from "lib/context/AuthenticationContext";
import "lib/services/apiClient/apiSetup";
import {ClientCommService} from "./lib/widget";



let isDev = true;
if (Environment.environment !== DEV && Environment.environment !== LOCAL) {
  isDev = false;
  if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    for (let [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value == "function" ? () => {} : null;
    }
  }
}

Logger.setLogLevel(isDev ? LogLevel.debug : LogLevel.warn);
ClientCommService.initializeCommunication();

ReactDOM.render(
  <React.StrictMode>
      <AuthenticationContextProvider />
  </React.StrictMode>,

  document.getElementById("root")
);
